import { render, staticRenderFns } from "./bulk-assign-group.vue?vue&type=template&id=36b2f6d0&scoped=true"
import script from "./bulk-assign-group.vue?vue&type=script&lang=js"
export * from "./bulk-assign-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2f6d0",
  null
  
)

export default component.exports